
// import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Paper, Draggable, IconButton, CloseIcon } from "../../utils/load.js"

//MUI
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Paper from '@mui/material/Paper';
import Draggable from 'react-draggable';
import { Button }  from "@mui/material";
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import UAuthButton from "../../components/mui/UAuthButton";
import UButton from "../../components/mui/UButton";

//API
import { fni18n } from "../../services/commonService";

const UPopupForm = (props) => {
    const type = props.type;
    /*
     * props.open (bool): true, false
     * props.onClose (fn): Close Handler
     * props.onSave (fn): save Event Handler
     * props.title (String): Popup Title
     * props.type (String): Button Type "1"= 닫기버튼 , "2"= 저장,닫기버튼
     * props.content(component): 팝업에 출력될 화면
     * 
     */

    return (
        <div>
            <Dialog
                open={props.open}
                onClose={props.onClose}
                PaperComponent={PaperComponent}
                aria-labelledby="draggable-dialog-title"
                fullWidth={true}
                maxWidth={props.maxWidth || 'lg'}
                BackdropProps={{
                    style: {
                      pointerEvents: 'none'
                    },
                    onClick: () => {}
                }}
                
                // PaperProps={{
                //     style: {
                //         width: '1000px',
                //         height: '888px',
                //         maxWidth: '1000px',
                //         maxHeight: '888px',
                //         align:"center",
                //     },
                // }}
            >
                <DialogTitle style={{ backgroundColor: "#F6F6F6", color:"#2F2F2F", borderBottom: "1px solid #444444", height:"50px", fontSize:"20px"}} id="draggable-dialog-title" onClose={props.onClose}>
                    { fni18n(props.title) || fni18n("상세") }
                    <IconButton aria-label="close" onClick={props.onClose} sx={{ position: 'absolute', right: 8, top: 8, color: (theme) => theme.palette.grey[500], }}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{padding:0}}>
                    <DialogContentText>
                        {/* 팝업 데이터가 출력될 영역 ex) /trans/TotalPage.jsx (UPopupForm < 검색) */}
                        {props.content}
                    </DialogContentText>
                </DialogContent>
                {type == "2" ? (
                    <DialogActions sx={{align: "center", backgroundColor:"#F6F6F6"}}>
                        <UAuthButton variant="contained" color="primary" onButtonClick={props.onSave}>저장</UAuthButton>
                        <UButton variant="outlined" onButtonClick={props.onClose}>닫기</UButton>
                    </DialogActions>
                ) : type == "3"? (
                    <DialogActions sx={{align: "center", backgroundColor:"#F6F6F6"}}>
                        <UAuthButton variant="contained" color="primary" onButtonClick={props.onSave}>저장</UAuthButton>
                        <UAuthButton variant="outlined" onButtonClick={props.onSecondBt}>{props.SecondBtName}</UAuthButton>
                        <UButton variant="outlined" onButtonClick={props.onClose}>닫기</UButton>
                    </DialogActions>
                ) : (
                    <DialogActions sx={{align: "center", backgroundColor:"#F6F6F6"}}>
                        <UButton variant="outlined" onButtonClick={props.onClose}>닫기</UButton>
                    </DialogActions>
                )}
            </Dialog>
        </div>
    )
}
export default UPopupForm;

function PaperComponent(props) {
    return (
      <Draggable
        handle="#draggable-dialog-title"
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...props} />
      </Draggable>
    );
}